<template>
  <div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <form
            @submit.prevent="submit"
            @keydown="form.onKeydown($event)"
            enctype="multipart/form-data"
          >
            <alert-error
              v-if="form.errors.get('message')"
              :form="form"
              :message="form.errors.get('message')"
            ></alert-error>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-body mb-n2">
                        <div class="row">
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="nom"
                                >Nom <span class="text-danger">*</span></label
                              >
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('nom'),
                                }"
                                id="nom"
                                v-model="form.nom"
                                type="text"
                                placeholder="Nom"
                                maxlength="50"
                              />
                              <has-error :form="form" field="nom"></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="email"
                                >Email {{ form.statut
                                }}<span class="text-danger">*</span></label
                              >
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('email'),
                                }"
                                id="email"
                                v-model="form.email"
                                type="email"
                                placeholder="Email"
                                maxlength="100"
                                required
                              />
                              <has-error :form="form" field="email"></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="type"
                                >Type <span class="text-danger">*</span></label
                              >
                              <v-custom-select
                                label="nom"
                                id="type"
                                :options="types"
                                :reduce="(type) => type.uuid"
                                v-model="form.type"
                                placeholder="Type tiers"
                              >
                                <template v-slot:option="{ nom }">
                                  <h5 style="margin: 0">{{ nom }}</h5>
                                </template>
                                <template #no-options>
                                  Aucune données
                                </template>
                                <template #search="{ attributes, events }">
                                  <input
                                    id="type"
                                    class="custom-select-height vs__search"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                              </v-custom-select>
                              <input
                                type="hidden"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('type'),
                                }"
                              />
                              <has-error :form="form" field="type"></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="societe">Societé </label>
                              <v-custom-select
                                label="nom"
                                id="societe"
                                :options="societes"
                                :reduce="(societe) => societe.uuid"
                                v-model="form.societe"
                                placeholder="Societé"
                              >
                                <template v-slot:option="{ nom }">
                                  <h5 style="margin: 0">{{ nom }}</h5>
                                </template>
                                <template #no-options>
                                  Aucune données
                                </template>
                                <template #search="{ attributes, events }">
                                  <input
                                    class="custom-select-height vs__search"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                              </v-custom-select>
                              <input
                                type="hidden"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('societe'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="societe"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="code_client">Code client </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('code_client'),
                                }"
                                id="code_client"
                                v-model="form.code_client"
                                type="text"
                                placeholder="Code client"
                                maxlength="30"
                              />
                              <has-error
                                :form="form"
                                field="code_client"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="telephone">Téléphone </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('telephone'),
                                }"
                                id="telephone"
                                v-model="form.telephone"
                                type="text"
                                placeholder="Téléphone"
                                maxlength="20"
                              />
                              <has-error
                                :form="form"
                                field="telephone"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="code_postal">Code postal </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('code_postal'),
                                }"
                                id="code_postal"
                                v-model="form.code_postal"
                                type="text"
                                placeholder="Code postal"
                                maxlength="20"
                              />
                              <has-error
                                :form="form"
                                field="code_postal"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="ville">Ville </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('ville'),
                                }"
                                id="ville"
                                v-model="form.ville"
                                type="text"
                                placeholder="Ville"
                                maxlength="50"
                              />
                              <has-error :form="form" field="ville"></has-error>
                            </div>
                          </div>

                          <div class="col-md-6 col-lg-4">
                            <div class="form-group">
                              <label for="pays">Pays </label>
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('pays'),
                                }"
                                id="pays"
                                v-model="form.pays"
                                type="text"
                                placeholder="Pays"
                                maxlength="50"
                              />
                              <has-error :form="form" field="pays"></has-error>
                            </div>
                          </div>
                          <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                              <label for="adresse">Adresse </label>
                              <textarea
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('adresse'),
                                }"
                                id="adresse"
                                v-model="form.adresse"
                                type="text"
                                placeholder="Adresse"
                                maxlength="100"
                              ></textarea>
                              <has-error
                                :form="form"
                                field="adresse"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 mb-4">
              <div class="col-md-12 text-right">
                <ButtonLoader
                  :busy="form.busy"
                  type="submit"
                  customClass="btn btn-custom-primary w-40"
                  loadText="Traitement en cours..."
                  Text="Enrégistrer"
                  style="min-width: 100px"
                ></ButtonLoader>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/client/client';
import { objectToFormData } from 'object-to-formdata';

import From from 'vform';
export default {
  data() {
    return {
      form: new From({
        type: null,
        societe: null,
        statut: '',
      }),

      types: [],
      societes: [],
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },

  methods: {
    init() {
      this.types = [];
      this.societes = [];

      this.id = this.$route.params.id;

      window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.TIERS + '/' + this.id, {
            params: { edit: true },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.types = resp1.data.types;
            this.societes = resp1.data.societes;

            Object.assign(this.form, resp2.data.tiers);
          })
        )
        .catch();
    },
    submit() {
      this.form._method = 'PUT';
      this.form
        .post(URL.TIERS + '/' + this.id, {
          transformRequest: [
            function (data) {
              return objectToFormData(data);
            },
          ],
        })
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
